<template>
    <div>
        <h3 class="my-3">Exports</h3>
        <vs-row>
            <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="px-0 pr-2 mb-base flex">
                <vs-input
                    class="w-full mr-4"
                    placeholder="Type to Search"
                    v-model="filters.search"
                /><vx-tooltip text="Refresh Data" color="primary" >
              <vs-button color="primary" type="filled" class="w-full" @click="init" :disabled="loading">
                <font-awesome-icon :icon="redoIcon" />
              </vs-button>
            </vx-tooltip>
            </vs-col>
        </vs-row>
        <vs-table :data="results" slot="no-body" :hoverFlat="true" stripe>
            <vs-tr>
                <vs-th style="min-width: 110px;">Date Created</vs-th>
                <vs-th style="min-width: 110px;">Module</vs-th>
                <vs-th style="min-width: 75px;">Status</vs-th>
                <vs-th>Download</vs-th>
            </vs-tr>
            <template>
                <template v-for="(item, index) in results">
                    <vs-tr :key="index">
                        <vs-td>
                            <FormatText :text="item.created_on" format="datetime" />
                        </vs-td>
                        <vs-td>
                            <template v-if="item.params.report_type == 'transaction'">
                                Transaction Report
                            </template>
                            <template v-else-if="item.params.report_type == 'summary'">
                                Summary Report
                            </template>
                            <template v-else-if="item.params.report_type == 'holding'">
                                Holding Report
                            </template>
                            <template v-else-if="item.params.report_type == 'capital_gain'">
                                Capital Gain Report
                            </template>
                            <template v-else>
                                {{ '' }}
                            </template>
                        </vs-td>
                        <vs-td>
                            <FormatText :text="item.status" format="select" :kwargs="[{label: 'Pending', value: 'p'}, {label: 'Scheduled', value: 's'},
                                {label: 'Processing', value: 'r'}, {label: 'Failed', value: 'f'}, {label: 'Success', value: 'c'}]" />
                        </vs-td>
                        <vs-td>
                            <template  v-if="item.status == 'c'">
                                <a target="_blank" :href="item.export_excel">
                                    <vx-tooltip text="Download Excel" color="primary">
                                        <vs-button color="primary" type="flat" class="ml-2">
                                            <font-awesome-icon :icon="excel" />
                                        </vs-button>
                                    </vx-tooltip>
                                </a>
                            </template>
                            <template v-else>
                                No File To Download
                            </template>
                        </vs-td>
                    </vs-tr>
                </template>
            </template>
        </vs-table>
        <template v-if="!disable_pagination">
            <vs-row v-if="total_results" class="mt-3 text-center">
                <vs-pagination :total="total_pages" v-model="current_page" goto class="mx-auto"></vs-pagination>
            </vs-row>
        </template>
    </div>
</template>

<script>
import { faRedo, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { Request } from '../../utils/requests';

export default {
	props: {
        embedded_mode: {
            required: false,
            default: false
        },
        embedded_filters: {
            required: false,
            default: () => {}
        },
        disable_pagination: {
            required: false,
            default: false
        },
    },
    data() {
        let offset = parseInt(this.$route.query.offset || 0);
        let limit = parseInt(this.$route.query.limit || 20);

        let current_page = Math.ceil((offset + limit) / limit);
        return  {

            results: [],

			next_url: null,
            loading: false,
            total_results: null,
            current_page: current_page,
            filters: {
                search: this.$route.query.search || null,
                ordering: this.$route.query.ordering || [],
                offset: offset,
                limit: limit,
            },

            submit_disabled: false,
            api_errors: {}
        }
    },
    mounted() {
        this.init()
    },
	computed: {
        total_pages() {
            if(this.total_results == 0 || this.filters.limit == 0)  return 1
            return Math.ceil(this.total_results/this.filters.limit)
        },
        redoIcon: () => faRedo,
        excel: () => faFileExcel,
    },
    watch: {
        filters: {
            deep: true,
            handler(newV) {

                if (this.current_page == null) return;

                if (this.timer) clearTimeout(this.timer);

                this.timer = setTimeout(() => {
                    this.$router.push({ name: this.$route.name, query: {...newV, ...this.embedded_query_params} });
                }, 800);
            }
        },
        "$route.query"(newV) {
            this.load_data(newV);
        },
        current_page(newV, oldV) {
            if (newV == oldV) return;
            this.filters.offset = (newV - 1) * this.filters.limit;
        },
    },
    methods: {
        init(){
            this.load_data(this.filters)
        },
        calculate_page() {
            if (this.filters.offset == 0) {
                this.current_page = 1;
            } else {
                this.current_page = Math.ceil(this.filters.offset / this.filters.limit);
            }
        },
        load_data(filters=null) {
            this.loading = true;
            this.$vs.loading();

            let url = this.$store.state.apiendpoints.excel_list

            let payload = filters

            if (!payload) payload = {};

            if (this.embedded_mode && this.embedded_filters) {
                payload = { ...payload, ...this.embedded_filters };
            }

            this.api_errors = {}

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.results = res.results
                    this.total_results = res.count
                    this.next_url = res.next;
                    this.loading = false;
                    this.$vs.loading.close();
                },
                (err) => {
                    this.loading = false;
                    this.$vs.loading.close();
                    if (err.error) {
                        this.api_errors = err.error

                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An Error Occurred, Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An Error Occurred, Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        }
    }
}
</script>
